/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Member_PortalInputs */

const en_admin_dashboard_member_portal = /** @type {(inputs: Admin_Dashboard_Member_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Member Portal`)
};

const de_admin_dashboard_member_portal = /** @type {(inputs: Admin_Dashboard_Member_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitglieder-Portal`)
};

const es_admin_dashboard_member_portal = /** @type {(inputs: Admin_Dashboard_Member_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal de Miembros`)
};

const fr_admin_dashboard_member_portal = /** @type {(inputs: Admin_Dashboard_Member_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portail Membres`)
};

const it_admin_dashboard_member_portal = /** @type {(inputs: Admin_Dashboard_Member_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portale membri`)
};

const pt_br2_admin_dashboard_member_portal = /** @type {(inputs: Admin_Dashboard_Member_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal do Membro`)
};

const pl_admin_dashboard_member_portal = /** @type {(inputs: Admin_Dashboard_Member_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal członków`)
};

const hu_admin_dashboard_member_portal = /** @type {(inputs: Admin_Dashboard_Member_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag portál`)
};

const ro_admin_dashboard_member_portal = /** @type {(inputs: Admin_Dashboard_Member_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal Membri`)
};

/**
* | output |
* | --- |
* | "Member Portal" |
*
* @param {Admin_Dashboard_Member_PortalInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_member_portal = /** @type {((inputs?: Admin_Dashboard_Member_PortalInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Member_PortalInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_member_portal(inputs)
	if (locale === "de") return de_admin_dashboard_member_portal(inputs)
	if (locale === "es") return es_admin_dashboard_member_portal(inputs)
	if (locale === "fr") return fr_admin_dashboard_member_portal(inputs)
	if (locale === "it") return it_admin_dashboard_member_portal(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_member_portal(inputs)
	if (locale === "pl") return pl_admin_dashboard_member_portal(inputs)
	if (locale === "hu") return hu_admin_dashboard_member_portal(inputs)
	return ro_admin_dashboard_member_portal(inputs)
});
export { admin_dashboard_member_portal as "admin.dashboard.member_portal" }